import { writable } from 'svelte/store';

export const gameRTPValue = writable('95');
export const hideHomeButton = writable(false);
export const exitUrl = writable(null);
export const gameInitParams = writable(null);
export const abTestParams = writable(null);
export const currencyDecimal = writable(null);

export const cashReelsSelectedValue = writable(null);
